import { z } from 'zod';
export const signedUrl = z.object({
    // URL to use when reading the object
    url: z.string(),
    uploadFilename: z.string(),
    // URL to use when uploading the object
    signedUploadUrl: z.string(),
    signedUploadProxyUrl: z.string(),
});
//# sourceMappingURL=signedUrl.js.map